import ViewBase from "../../../../framework/core/mvvm/view_base";


const {ccclass, property} = cc._decorator;

@ccclass
export  class CaiChiTipsView extends ViewBase {
    @property(cc.Animation)
    effectAnim: cc.Animation = null
}
